import React, { useContext } from 'react';
import { DetailContext } from '@eas/common-web';
import { useDisciplinaryProceedingsPermission } from '../../../es-file/es-file-permission';
import { DocumentFields as Documents } from '../../../es-file/fields/documents/documents';

export function DocumentFields() {
  const { source } = useContext(DetailContext);
  const { hasPermission } = useDisciplinaryProceedingsPermission(source.data);

  return (
    <>
      <Documents hasPermission={hasPermission} />
    </>
  );
}
